if($('.in-index').length){
    if($('.welcome p img[style="float: right;"]').length){
        $('.welcome').after($('.welcome p img[style="float: right;"]').closest('p'))
    }
}

